(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-eveora-body-adhesive-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'page-eveora-body-adhesive-hero';
  if (window.__eveoraHeroGallery) return;
  window.__eveoraHeroGallery = true;

  function stripOf(sec) { return sec ? sec.querySelector('.' + NS + '__g_main') : null; }
  function thumbsOf(sec) { return Array.prototype.slice.call(sec.querySelectorAll('.' + NS + '__g_thumb')); }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.' + NS + '__gnav');
    if (nav) {
      var g = stripOf(nav.closest('.' + NS + '__hero_sec'));
      if (g) g.scrollBy({ left: (parseInt(nav.getAttribute('data-dir'), 10) || 1) * g.clientWidth, behavior: 'smooth' });
      return;
    }
    var th = e.target.closest('.' + NS + '__g_thumb');
    if (!th) return;
    var sec = th.closest('.' + NS + '__hero_sec');
    var g2 = stripOf(sec);
    if (!g2) return;
    var ths0 = thumbsOf(sec);
    var off0 = g2.querySelectorAll('.' + NS + '__g_slide').length - ths0.length;
    if (off0 < 0) off0 = 0;
    g2.scrollTo({ left: (ths0.indexOf(th) + off0) * g2.clientWidth, behavior: 'smooth' });
  });

  var raf = null;
  document.addEventListener('scroll', function (e) {
    var g = e.target;
    if (!g.classList || !g.classList.contains(NS + '__g_main')) return;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var sec = g.closest('.' + NS + '__hero_sec');
      if (!sec) return;
      var ths = thumbsOf(sec);
      if (!ths.length) return;
      var off = g.querySelectorAll('.' + NS + '__g_slide').length - ths.length;
      if (off < 0) off = 0;
      var idx = Math.round(g.scrollLeft / g.clientWidth) - off;
      if (idx < 0) idx = 0;
      if (idx > ths.length - 1) idx = ths.length - 1;
      ths.forEach(function (x, i2) { x.classList.toggle(NS + '__on', i2 === idx); });
      ths[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }, true);

  function syncPrice() {
    document.querySelectorAll('.' + NS + '__hero_sec').forEach(function (sec) {
      var priceEl = sec.querySelector('.' + NS + '__price');
      if (!priceEl) return;
      var checked = sec.querySelector('.' + NS + '__tier input:checked');
      var tier = checked && checked.closest('.' + NS + '__tier');
      var tp = tier && tier.querySelector('.' + NS + '__tprice');
      if (tp) priceEl.textContent = tp.textContent.trim();
    });
  }
  function syncGalleryToTier(tier) {
    var src = tier.getAttribute('data-gimg');
    if (!src) return;
    var sec = tier.closest('.' + NS + '__hero_sec');
    var g = stripOf(sec);
    var hero = g && g.querySelector('.' + NS + '__g_slide_hero');
    if (!hero) return;
    var img = hero.querySelector('img');
    if (!img) {
      hero.innerHTML = '';
      img = document.createElement('img');
      img.className = NS + '__gimg';
      hero.appendChild(img);
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.alt = tier.getAttribute('data-galt') || '';
    g.scrollTo({ left: 0, behavior: 'smooth' });
  }

  document.addEventListener('change', function (e) {
    var tier = e.target.closest && e.target.closest('.' + NS + '__tier');
    if (!tier) return;
    syncPrice();
    syncGalleryToTier(tier);
  });
  syncPrice();

  function paintRating(scope) {
    var spans = (scope || document).querySelectorAll('.' + NS + '__rating > span:not(.' + NS + '__hearts)');
    spans.forEach(function (sp) {
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            if (!/[0-9.,\/]/.test(n.nodeValue)) return;
            var frag = document.createDocumentFragment();
            n.nodeValue.split(/([0-9.,\/]+)/).forEach(function (part, i) {
              if (!part) return;
              if (i % 2) {
                var s = document.createElement('span');
                s.className = NS + '__ratnum';
                s.textContent = part;
                frag.appendChild(s);
              } else {
                frag.appendChild(document.createTextNode(part));
              }
            });
            node.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.className !== NS + '__ratnum') {
            walk(n);
          }
        });
      })(sp);
    });
  }
  paintRating();
  document.addEventListener('shopify:section:load', function (e) { paintRating(e.target); syncPrice(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-eveora-body-adhesive-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'page-eveora-body-adhesive-social-proof';
  if (window.__eveoraRevDrag) return;
  window.__eveoraRevDrag = true;
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var g = e.target.closest('.' + NS + '__rev_grid');
    if (!g || g.scrollWidth <= g.clientWidth) return;
    drag = { g: g, x: e.clientX, sl: g.scrollLeft };
    g.classList.add(NS + '__dragging');
    e.preventDefault();
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.g.scrollLeft = drag.sl - (e.clientX - drag.x);
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    document.addEventListener(t, function () {
      if (!drag) return;
      drag.g.classList.remove(NS + '__dragging');
      drag = null;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storelaunch-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.__slProductPageScript) return;
  window.__slProductPageScript = true;

  function parseJsonScript(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return [];
    try { return JSON.parse(node.textContent || "[]"); } catch (error) { return []; }
  }

  function bindOnce(node, key) {
    if (!node || node.getAttribute("data-sl-bound-" + key) === "true") return false;
    node.setAttribute("data-sl-bound-" + key, "true");
    return true;
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") return window.Shopify.formatMoney(cents);
    try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency || "USD" }).format(Number(cents || 0) / 100); } catch (error) { return String(cents || ""); }
  }

  function refreshCartCount(section) {
    var url = section && section.getAttribute("data-sl-cart-json-url");
    if (!url || !window.fetch) return Promise.resolve();
    return fetch(url, { headers: { Accept: "application/json" } }).then(function (response) { return response.ok ? response.json() : null; }).then(function (cart) {
      if (!cart || typeof cart.item_count !== "number") return;
      document.querySelectorAll("[data-sl-cart-count]").forEach(function (node) {
        node.textContent = String(cart.item_count);
        var link = node.closest("[data-sl-cart-link]");
        if (link) link.setAttribute("aria-label", (link.getAttribute("data-sl-cart-label-template") || "Cart with __COUNT__ items").replace("__COUNT__", String(cart.item_count)));
      });
    }).catch(function () { return undefined; });
  }

  // The page is often injected into a merchant's own theme, whose header count
  // and cart drawer know nothing about this form. Tell them about each add the
  // way the theme's own product form would.
  var standardEvents = null;
  function loadStandardEvents() {
    if (standardEvents) return standardEvents;
    var url = "";
    try {
      var map = document.querySelector('script[type="importmap"]');
      var imports = map ? JSON.parse(map.textContent || "{}").imports : null;
      url = (imports && imports["@shopify/events"]) || "";
    } catch (error) { url = ""; }
    standardEvents = url ? import(url).catch(function () { return null; }) : Promise.resolve(null);
    return standardEvents;
  }

  function hostCartElement() {
    var element = document.querySelector("cart-notification, cart-drawer");
    return element && typeof element.renderContents === "function" && typeof element.getSectionsToRender === "function" ? element : null;
  }

  function hostCartSectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) === -1) ids.push(String(id)); }
    // Horizon-era themes re-render these from the add response.
    document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (node) { add(node.getAttribute("data-section-id")); });
    // Dawn-family drawers and notifications name their own sections.
    var element = hostCartElement();
    if (element) { try { element.getSectionsToRender().forEach(function (entry) { add(entry && entry.id); }); } catch (error) { return ids; } }
    return ids;
  }

  function cartJsonUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + "cart.js";
  }

  // Shopify's standard storefront events (what Horizon's cart icon and drawer
  // listen for): announce the add before it settles, then resolve with the cart.
  function announceCartAdd(form, variantId, quantity, request) {
    loadStandardEvents().then(function (events) {
      var LinesUpdate = events && events.CartLinesUpdateEvent;
      if (!LinesUpdate) return;
      var deferred = LinesUpdate.createPromise();
      // Listeners attach their own handlers; this only stops an unhandled-rejection log when none does.
      deferred.promise.catch(function () {});
      form.dispatchEvent(new LinesUpdate({ action: "add", context: "product", lines: [{ merchandiseId: variantId, quantity: quantity }], promise: deferred.promise }));
      // Shopify's contract: a declined add resolves with userErrors; a failed
      // request rejects and dispatches shopify:cart:error.
      function settle(item, userErrors) {
        return fetch(cartJsonUrl(), { headers: { Accept: "application/json" } }).then(function (response) { return response.json(); }).then(function (cart) {
          deferred.resolve({ cart: LinesUpdate.createCartFromAjaxResponse(cart), userErrors: userErrors, warnings: [], detail: { items: cart.items, sections: item && item.sections, itemCount: quantity, source: "storelaunch-product-page", didError: userErrors.length > 0 } });
        });
      }
      function fail(error) {
        var CartError = events && events.CartErrorEvent;
        if (CartError) { try { form.dispatchEvent(new CartError({ error: (error && error.message) || "Cart request failed", code: "SERVICE_UNAVAILABLE" })); } catch (dispatchError) { /* a listener must not break the add */ } }
        deferred.reject(error);
      }
      request.then(function (item) { return settle(item, []); }, function (error) {
        if (error && error.declined) return settle(null, [{ message: error.message, code: "INVALID", field: ["lines"] }]);
        fail(error);
      }).catch(fail);
    });
  }

  // Older themes: hand the drawer its refreshed sections, and fire the
  // de-facto cart events other themes and apps listen for.
  function renderHostCart(item) {
    var element = hostCartElement();
    if (element && item && item.sections) {
      try { element.classList.remove("is-empty"); element.renderContents(item); } catch (error) { element = null; }
    }
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: item }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: item }));
      if (typeof window.publish === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "storelaunch-product-page", productVariantId: item && item.variant_id });
      }
    } catch (error) { return undefined; }
  }

  function addToCart(form, url) {
    var data = new FormData(form);
    var sectionIds = hostCartSectionIds();
    if (sectionIds.length) { data.append("sections", sectionIds.join(",")); data.append("sections_url", (window.location && window.location.pathname) || "/"); }
    var variantId = String(data.get("id") || "");
    var quantity = Math.max(1, Number(data.get("quantity")) || 1);
    var request = fetch(url || (form.action + ".js"), { method: "POST", body: data, headers: { Accept: "application/json" } }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.status) {
          // A 4xx (other than 429) is Shopify declining the add; anything else is a failed request.
          var cartError = new Error(body.description || body.message || "Cart request failed");
          cartError.declined = response.status >= 400 && response.status < 500 && response.status !== 429;
          throw cartError;
        }
        return body;
      });
    });
    announceCartAdd(form, variantId, quantity, request);
    return request.then(function (item) { renderHostCart(item); return item; });
  }

  function setGalleryMedia(section, mediaId) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    var selectedThumb = null;
    // A variant image that is not in the gallery would hide every slide.
    var hasItem = Array.prototype.some.call(items, function (item) { return item.getAttribute("data-media-id") === String(mediaId); });
    if (!hasItem) return;
    thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute("data-media-id") === String(mediaId);
      if (active) selectedThumb = thumb;
      thumb.classList.toggle("is-active", active);
      thumb.setAttribute("aria-pressed", String(active));
    });
    items.forEach(function (item) { item.classList.toggle("is-active", item.getAttribute("data-media-id") === String(mediaId)); });
    if (selectedThumb && selectedThumb.scrollIntoView) selectedThumb.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function setupGallery(section) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    if (!thumbs.length || !items.length) return;
    thumbs.forEach(function (thumb) {
      if (!bindOnce(thumb, "gallery")) return;
      thumb.addEventListener("click", function () { setGalleryMedia(section, thumb.getAttribute("data-media-id")); });
    });
  }

  function setupDialog(section) {
    var dialog = section.querySelector("[data-sl-dialog]");
    var openButton = section.querySelector("[data-sl-open-dialog]");
    var closeButton = section.querySelector("[data-sl-close-dialog]");
    if (!dialog || !openButton || !bindOnce(dialog, "dialog")) return;
    var lastFocused = null;
    openButton.addEventListener("click", function () {
      lastFocused = document.activeElement;
      if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
      if (closeButton) closeButton.focus();
    });
    if (closeButton) closeButton.addEventListener("click", function () { if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); });
    dialog.addEventListener("click", function (event) { if (event.target === dialog && typeof dialog.close === "function") dialog.close(); });
    dialog.addEventListener("close", function () { if (lastFocused && lastFocused.focus) lastFocused.focus(); });
  }

  function setupHeader(section) {
    var button = section.querySelector("[data-sl-mobile-menu-button]");
    var drawer = section.querySelector("[data-sl-mobile-drawer]");
    if (!button || !drawer || !bindOnce(button, "menu")) return;
    function close() { button.setAttribute("aria-expanded", "false"); drawer.hidden = true; }
    button.addEventListener("click", function () {
      var expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      drawer.hidden = expanded;
      if (!expanded) { var firstLink = drawer.querySelector("a"); if (firstLink) firstLink.focus(); }
    });
    drawer.querySelectorAll("a").forEach(function (link) { link.addEventListener("click", close); });
    section.addEventListener("keydown", function (event) { if (event.key === "Escape") { close(); button.focus(); } });
  }

  function setupVideoDialogs(section) {
    section.querySelectorAll("[data-sl-video-open]").forEach(function (openButton) {
      if (!bindOnce(openButton, "video-open")) return;
      var dialogId = openButton.getAttribute("aria-controls");
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      var closeButton = dialog.querySelector("[data-sl-video-close]");
      var video = dialog.querySelector("[data-sl-video]");
      openButton.addEventListener("click", function () {
        if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
        if (video && typeof video.play === "function") video.play().catch(function () {});
      });
      function close() { if (video) video.pause(); if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); }
      if (closeButton) closeButton.addEventListener("click", close);
      dialog.addEventListener("click", function (event) { if (event.target === dialog) close(); });
      dialog.addEventListener("close", function () { if (video) video.pause(); });
    });
  }

  function setupQuantity(section) {
    var control = section.querySelector("[data-sl-quantity-control]");
    var input = control && control.querySelector("[data-sl-quantity-input]");
    if (!control || !input || !bindOnce(control, "quantity")) return;
    var choiceInputs = control.querySelectorAll("[data-sl-quantity-choice]");
    function normalize() { var value = Math.max(1, Math.floor(Number(input.value) || 1)); input.value = String(value); return value; }
    function syncChoiceState() { choiceInputs.forEach(function (choice) { var label = choice.closest(".sl-product-quantity-option"); if (label) label.classList.toggle("is-selected", choice.checked); }); }
    control.querySelectorAll("[data-sl-quantity-step]").forEach(function (button) { button.addEventListener("click", function () { input.value = String(Math.max(1, (Number(input.value) || 1) + Number(button.getAttribute("data-sl-quantity-step") || 0))); input.dispatchEvent(new Event("change", { bubbles: true })); }); });
    choiceInputs.forEach(function (choice) { choice.addEventListener("change", function () { input.value = String(Math.max(1, Math.floor(Number(choice.value) || 1))); syncChoiceState(); }); });
    input.addEventListener("change", normalize);
    input.addEventListener("blur", normalize);
    syncChoiceState();
  }

  function variantMediaId(variant) {
    if (!variant) return "";
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_media && typeof variant.featured_media === "number") return variant.featured_media;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    return variant.featured_image && typeof variant.featured_image === "number" ? variant.featured_image : "";
  }

  function setupProductForm(section) {
    var form = section.querySelector("form.sl-product-form");
    if (!form || !bindOnce(form, "product-form")) return;
    var variants = parseJsonScript(section, "[data-sl-variants]");
    var variantInput = form.querySelector("[data-sl-variant-id]");
    var addButton = form.querySelector("[data-sl-add-to-cart]");
    var addLabel = addButton && (addButton.querySelector("[data-sl-add-to-cart-label]") || addButton);
    var status = form.querySelector("[data-sl-form-status]");
    var price = section.querySelector("[data-sl-price]");
    var compareAt = section.querySelector("[data-sl-compare-at]");
    var stickyPrice = section.querySelector("[data-sl-sticky-price]");
    var optionInputs = form.querySelectorAll("[data-sl-option-input]");
    var planInputs = form.querySelectorAll("[data-sl-selling-plan-choice]");
    var currency = section.getAttribute("data-sl-currency") || "USD";
    var labels = { add: section.getAttribute("data-sl-add-label") || "Add to cart", soldOut: section.getAttribute("data-sl-sold-out-label") || "Sold out", adding: section.getAttribute("data-sl-adding-label") || "Adding to cart…", added: section.getAttribute("data-sl-added-label") || "Added to cart.", error: section.getAttribute("data-sl-error-label") || "Unable to add this item." };
    var submitting = false;

    function selectedValues() {
      var values = [];
      optionInputs.forEach(function (input) { if (input.checked) values[Number(input.getAttribute("data-option-position") || 1) - 1] = input.value; });
      return values;
    }
    function findVariant() {
      if (!variants.length) return null;
      // No option pickers: the bundle app owns the variant, so follow the form's id field.
      if (!optionInputs.length) {
        var currentId = variantInput ? String(variantInput.value) : "";
        return variants.find(function (variant) { return String(variant.id) === currentId; }) || variants[0];
      }
      var selected = selectedValues();
      return variants.find(function (variant) { var options = Array.isArray(variant.options) ? variant.options : []; return selected.every(function (value, index) { return value === undefined || options[index] === value; }); }) || variants[0];
    }
    function selectedPlanId() { var checked = form.querySelector("[data-sl-selling-plan-choice]:checked"); return checked ? checked.value : ""; }
    function allocationFor(variant, planId) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
      return allocations.find(function (allocation) { return String(allocation.selling_plan_id) === String(planId); }) || null;
    }
    function syncSelectedLabels() {
      section.querySelectorAll("[data-sl-selected-option]").forEach(function (label) { var input = form.querySelector('[data-sl-option-input][data-option-position="' + label.getAttribute("data-sl-selected-option") + '"]:checked'); if (input) label.textContent = input.value; });
      section.querySelectorAll(".sl-product-option").forEach(function (label) { var input = label.querySelector("[data-sl-option-input]"); if (input) label.classList.toggle("is-selected", Boolean(input.checked)); });
    }
    function syncOptionAvailability() {
      var selected = selectedValues();
      optionInputs.forEach(function (input) {
        var optionIndex = Number(input.getAttribute("data-option-position") || 1) - 1;
        var available = variants.some(function (variant) {
          if (variant.available === false) return false;
          var options = Array.isArray(variant.options) ? variant.options : [];
          if (options[optionIndex] !== input.value) return false;
          return selected.every(function (value, index) { return index === optionIndex || value === undefined || options[index] === value; });
        });
        var label = input.closest(".sl-product-option");
        input.disabled = !available && !input.checked;
        input.setAttribute("aria-disabled", String(!available));
        if (label) label.classList.toggle("is-unavailable", !available);
      });
    }
    function syncPlanCards() { form.querySelectorAll("[data-sl-plan-card]").forEach(function (card) { var input = card.querySelector("[data-sl-selling-plan-choice]"); card.classList.toggle("is-selected", Boolean(input && input.checked)); }); }
    function syncPlanPrices(variant) {
      section.querySelectorAll("[data-sl-plan-price]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        if (cents !== undefined) node.textContent = formatMoney(cents, currency);
      });
      // The struck-through price belongs to the same variant (or its plan allocation).
      section.querySelectorAll("[data-sl-plan-compare]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        var compare = allocation && allocation.compare_at_price ? allocation.compare_at_price : variant && variant.compare_at_price;
        var show = Number(compare || 0) > Number(cents || 0);
        node.hidden = !show;
        node.textContent = show ? formatMoney(compare, currency) : "";
      });
    }
    function syncVariant() {
      var variant = findVariant();
      syncOptionAvailability();
      syncSelectedLabels();
      if (!variant) return null;
      var isAvailable = variant.available !== false;
      var formattedPrice = formatMoney(variant.price, currency);
      var selectedPlan = selectedPlanId();
      var selectedAllocation = allocationFor(variant, selectedPlan);
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = selectedAllocation && selectedAllocation.price !== undefined ? formatMoney(selectedAllocation.price, currency) : formattedPrice;
      if (stickyPrice) stickyPrice.textContent = price ? price.textContent : formattedPrice;
      if (compareAt) { var compare = Number(variant.compare_at_price || 0); var current = Number(variant.price || 0); compareAt.hidden = !(compare > current); compareAt.textContent = compare > current ? formatMoney(compare, currency) : ""; }
      if (addButton) { addButton.disabled = !isAvailable || submitting; addLabel.textContent = isAvailable ? labels.add : labels.soldOut; }
      syncPlanPrices(variant);
      syncPlanCards();
      var mediaId = variantMediaId(variant);
      if (mediaId) setGalleryMedia(section, mediaId);
      section.setAttribute("data-selected-variant", String(variant.id));
      return variant;
    }
    // Like the theme's own product form: the URL names the chosen variant, so a
    // shared link or a reload opens it. The wizard's sandboxed preview may refuse
    // the rewrite, which is harmless there.
    function syncVariantUrl() {
      var variant = syncVariant();
      if (!variant) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState(window.history.state, "", url.toString());
      } catch (error) {}
    }
    optionInputs.forEach(function (input) { input.addEventListener("change", syncVariantUrl); });
    planInputs.forEach(function (input) { input.addEventListener("change", syncVariant); });
    setupQuantity(section);
    syncVariant();
    var stickyButton = section.querySelector("[data-sl-mobile-sticky-add]");
    if (stickyButton && bindOnce(stickyButton, "sticky")) stickyButton.addEventListener("click", function () { var variant = syncVariant(); if (!variant || variant.available === false || !addButton) return; if (typeof form.requestSubmit === "function") form.requestSubmit(addButton); else addButton.click(); });
    if (section.getAttribute("data-sl-ajax") !== "true" || !window.fetch || !window.FormData) return;
    loadStandardEvents();
    form.addEventListener("submit", function (event) {
      if (submitting) return;
      event.preventDefault();
      submitting = true;
      if (status) status.textContent = labels.adding;
      syncVariant();
      addToCart(form, section.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = labels.added; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = labels.error; }).finally(function () { submitting = false; syncVariant(); });
    });
  }

  function setupRelatedForms(section) {
    section.querySelectorAll("[data-sl-related-form] form.sl-product-related__form").forEach(function (form) {
      var config = form.closest("[data-sl-related-form]") || section;
      if (!bindOnce(form, "related-form") || config.getAttribute("data-sl-ajax") !== "true") return;
      var button = form.querySelector("[data-sl-related-add]");
      var status = config.querySelector("[data-sl-related-status]");
      form.addEventListener("submit", function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (button) button.disabled = true;
        if (status) status.textContent = config.getAttribute("data-sl-adding-label") || "Adding to cart…";
        addToCart(form, config.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = config.getAttribute("data-sl-added-label") || "Added to cart."; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = config.getAttribute("data-sl-error-label") || "Unable to add this item."; }).finally(function () { if (button) button.disabled = false; });
      });
    });
  }

  // Related products with nothing picked: fetch Shopify's recommendations for
  // this product through the section itself and swap them in.
  function setupRecommendations(section) {
    var url = section.getAttribute("data-sl-related-recommendations");
    if (!url || !window.fetch || !window.DOMParser || !bindOnce(section, "recommendations")) return;
    fetch(url, { headers: { Accept: "text/html" } }).then(function (response) { return response.ok ? response.text() : ""; }).then(function (html) {
      if (!html) return;
      var next = new DOMParser().parseFromString(html, "text/html").querySelector(".sl-product-related");
      if (!next || !next.querySelector(".sl-product-related__card")) return;
      section.replaceWith(next);
      setupWithin(next);
    }).catch(function () { return undefined; });
  }

  function setupTestimonials(section) {
    var tabs = section.querySelectorAll("[data-sl-topic-tab]");
    var cards = section.querySelectorAll("[data-sl-testimonial-card]");
    if (!tabs.length || !cards.length) return;
    // Quotes only (video tiles are not topic cards). Like the React renderer, a
    // tab that matches no quote shows them all rather than an empty grid.
    function applyTopic(topic) {
      var shown = 0;
      cards.forEach(function (card) { var cardTopic = card.getAttribute("data-sl-topic") || "all"; card.hidden = topic !== "all" && cardTopic !== "all" && cardTopic !== topic; if (!card.hidden) shown += 1; });
      if (!shown) cards.forEach(function (card) { card.hidden = false; });
    }
    tabs.forEach(function (tab) { if (!bindOnce(tab, "testimonial-tab")) return; tab.addEventListener("click", function () { var topic = tab.getAttribute("data-sl-topic") || "all"; tabs.forEach(function (candidate) { var active = candidate === tab; candidate.classList.toggle("is-active", active); candidate.setAttribute("aria-selected", String(active)); }); applyTopic(topic); }); });
    applyTopic(tabs[0].getAttribute("data-sl-topic") || "all");
  }

  function setupReviews(section) {
    var list = section.querySelector("[data-sl-review-list]");
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-sl-review-card]"));
    if (!list || !cards.length || !bindOnce(section, "reviews")) return;
    var sortChips = section.querySelectorAll("[data-sl-review-sort]");
    var ratingChips = section.querySelectorAll("[data-sl-review-rating]");
    var more = section.querySelector("[data-sl-review-more]");
    var sortMode = "latest";
    var ratingFilter = "all";
    var showingAll = false;
    var initialCount = 5;
    function number(card, name) { return Number(card.getAttribute(name) || 0); }
    function compare(a, b) {
      if (sortMode === "highest") return number(b, "data-rating") - number(a, "data-rating");
      if (sortMode === "lowest") return number(a, "data-rating") - number(b, "data-rating");
      if (sortMode === "helpful") return number(b, "data-helpful") - number(a, "data-helpful");
      if (sortMode === "oldest") return number(b, "data-review-index") - number(a, "data-review-index");
      return number(a, "data-review-index") - number(b, "data-review-index");
    }
    function apply() {
      var shown = 0;
      cards.slice().sort(compare).forEach(function (card) {
        list.appendChild(card);
        var matches = ratingFilter === "all" || card.getAttribute("data-rating") === ratingFilter;
        card.hidden = !matches || (!showingAll && shown >= initialCount);
        if (matches) shown += 1;
      });
      if (more) more.hidden = showingAll || shown <= initialCount;
    }
    function activate(chips, chosen) {
      chips.forEach(function (chip) { var active = chip === chosen; chip.classList.toggle("is-active", active); chip.setAttribute("aria-pressed", String(active)); });
    }
    sortChips.forEach(function (chip) { chip.addEventListener("click", function () { sortMode = chip.getAttribute("data-sl-review-sort") || "latest"; activate(sortChips, chip); apply(); }); });
    ratingChips.forEach(function (chip) { chip.addEventListener("click", function () { ratingFilter = chip.getAttribute("data-sl-review-rating") || "all"; activate(ratingChips, chip); apply(); }); });
    section.querySelectorAll("[data-sl-review-helpful]").forEach(function (button) { button.addEventListener("click", function () { var active = button.getAttribute("aria-pressed") === "true"; button.setAttribute("aria-pressed", String(!active)); button.classList.toggle("is-active", !active); }); });
    if (more) more.addEventListener("click", function () { showingAll = true; apply(); });
    apply();
  }

  // Long copy behind "Read more" on a phone. The clamp CSS only applies once
  // data-sl-clamp-ready is set, and the button only shows when the clamped
  // text really overflows, so short copy and wide screens never get one.
  function measureClamp(copy, toggle) {
    if (copy.classList.contains("is-expanded")) return;
    var overflows = copy.scrollHeight > copy.clientHeight + 1;
    if (overflows) copy.setAttribute("data-sl-clamp-overflow", ""); else copy.removeAttribute("data-sl-clamp-overflow");
    toggle.hidden = !overflows;
  }

  function setupClamps(root) {
    root.querySelectorAll("[data-sl-clamp]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (!toggle || !toggle.hasAttribute("data-sl-clamp-toggle") || !bindOnce(copy, "clamp")) return;
      copy.setAttribute("data-sl-clamp-ready", "");
      measureClamp(copy, toggle);
      toggle.addEventListener("click", function () {
        var expanded = copy.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        toggle.textContent = toggle.getAttribute(expanded ? "data-sl-less-label" : "data-sl-more-label") || toggle.textContent;
      });
    });
  }

  function remeasureClamps() {
    document.querySelectorAll("[data-sl-clamp-ready]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (toggle && toggle.hasAttribute("data-sl-clamp-toggle")) measureClamp(copy, toggle);
    });
  }

  function setupWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var sections = [];
    if (root.matches && root.matches("[data-sl-product-section]")) sections.push(root);
    root.querySelectorAll("[data-sl-product-section]").forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) { setupGallery(section); setupDialog(section); setupHeader(section); setupVideoDialogs(section); setupProductForm(section); setupRelatedForms(section); setupRecommendations(section); setupTestimonials(section); setupReviews(section); });
    // Every section's copy, not only those that load this script.
    setupClamps(root);
  }

  function setup() {
    setupWithin(document);
    if (document.documentElement.getAttribute("data-sl-global-events") === "true") return;
    document.documentElement.setAttribute("data-sl-global-events", "true");
    document.addEventListener("shopify:section:load", function (event) { setupWithin(event.target); });
    var resizeTimer = 0;
    window.addEventListener("resize", function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(remeasureClamps, 150); });
    // Web fonts change line heights after the first measure.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureClamps);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storelaunch-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.__slProductPageScript) return;
  window.__slProductPageScript = true;

  function parseJsonScript(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return [];
    try { return JSON.parse(node.textContent || "[]"); } catch (error) { return []; }
  }

  function bindOnce(node, key) {
    if (!node || node.getAttribute("data-sl-bound-" + key) === "true") return false;
    node.setAttribute("data-sl-bound-" + key, "true");
    return true;
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") return window.Shopify.formatMoney(cents);
    try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency || "USD" }).format(Number(cents || 0) / 100); } catch (error) { return String(cents || ""); }
  }

  function refreshCartCount(section) {
    var url = section && section.getAttribute("data-sl-cart-json-url");
    if (!url || !window.fetch) return Promise.resolve();
    return fetch(url, { headers: { Accept: "application/json" } }).then(function (response) { return response.ok ? response.json() : null; }).then(function (cart) {
      if (!cart || typeof cart.item_count !== "number") return;
      document.querySelectorAll("[data-sl-cart-count]").forEach(function (node) {
        node.textContent = String(cart.item_count);
        var link = node.closest("[data-sl-cart-link]");
        if (link) link.setAttribute("aria-label", (link.getAttribute("data-sl-cart-label-template") || "Cart with __COUNT__ items").replace("__COUNT__", String(cart.item_count)));
      });
    }).catch(function () { return undefined; });
  }

  // The page is often injected into a merchant's own theme, whose header count
  // and cart drawer know nothing about this form. Tell them about each add the
  // way the theme's own product form would.
  var standardEvents = null;
  function loadStandardEvents() {
    if (standardEvents) return standardEvents;
    var url = "";
    try {
      var map = document.querySelector('script[type="importmap"]');
      var imports = map ? JSON.parse(map.textContent || "{}").imports : null;
      url = (imports && imports["@shopify/events"]) || "";
    } catch (error) { url = ""; }
    standardEvents = url ? import(url).catch(function () { return null; }) : Promise.resolve(null);
    return standardEvents;
  }

  function hostCartElement() {
    var element = document.querySelector("cart-notification, cart-drawer");
    return element && typeof element.renderContents === "function" && typeof element.getSectionsToRender === "function" ? element : null;
  }

  function hostCartSectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) === -1) ids.push(String(id)); }
    // Horizon-era themes re-render these from the add response.
    document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (node) { add(node.getAttribute("data-section-id")); });
    // Dawn-family drawers and notifications name their own sections.
    var element = hostCartElement();
    if (element) { try { element.getSectionsToRender().forEach(function (entry) { add(entry && entry.id); }); } catch (error) { return ids; } }
    return ids;
  }

  function cartJsonUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + "cart.js";
  }

  // Shopify's standard storefront events (what Horizon's cart icon and drawer
  // listen for): announce the add before it settles, then resolve with the cart.
  function announceCartAdd(form, variantId, quantity, request) {
    loadStandardEvents().then(function (events) {
      var LinesUpdate = events && events.CartLinesUpdateEvent;
      if (!LinesUpdate) return;
      var deferred = LinesUpdate.createPromise();
      // Listeners attach their own handlers; this only stops an unhandled-rejection log when none does.
      deferred.promise.catch(function () {});
      form.dispatchEvent(new LinesUpdate({ action: "add", context: "product", lines: [{ merchandiseId: variantId, quantity: quantity }], promise: deferred.promise }));
      // Shopify's contract: a declined add resolves with userErrors; a failed
      // request rejects and dispatches shopify:cart:error.
      function settle(item, userErrors) {
        return fetch(cartJsonUrl(), { headers: { Accept: "application/json" } }).then(function (response) { return response.json(); }).then(function (cart) {
          deferred.resolve({ cart: LinesUpdate.createCartFromAjaxResponse(cart), userErrors: userErrors, warnings: [], detail: { items: cart.items, sections: item && item.sections, itemCount: quantity, source: "storelaunch-product-page", didError: userErrors.length > 0 } });
        });
      }
      function fail(error) {
        var CartError = events && events.CartErrorEvent;
        if (CartError) { try { form.dispatchEvent(new CartError({ error: (error && error.message) || "Cart request failed", code: "SERVICE_UNAVAILABLE" })); } catch (dispatchError) { /* a listener must not break the add */ } }
        deferred.reject(error);
      }
      request.then(function (item) { return settle(item, []); }, function (error) {
        if (error && error.declined) return settle(null, [{ message: error.message, code: "INVALID", field: ["lines"] }]);
        fail(error);
      }).catch(fail);
    });
  }

  // Older themes: hand the drawer its refreshed sections, and fire the
  // de-facto cart events other themes and apps listen for.
  function renderHostCart(item) {
    var element = hostCartElement();
    if (element && item && item.sections) {
      try { element.classList.remove("is-empty"); element.renderContents(item); } catch (error) { element = null; }
    }
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: item }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: item }));
      if (typeof window.publish === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "storelaunch-product-page", productVariantId: item && item.variant_id });
      }
    } catch (error) { return undefined; }
  }

  function addToCart(form, url) {
    var data = new FormData(form);
    var sectionIds = hostCartSectionIds();
    if (sectionIds.length) { data.append("sections", sectionIds.join(",")); data.append("sections_url", (window.location && window.location.pathname) || "/"); }
    var variantId = String(data.get("id") || "");
    var quantity = Math.max(1, Number(data.get("quantity")) || 1);
    var request = fetch(url || (form.action + ".js"), { method: "POST", body: data, headers: { Accept: "application/json" } }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.status) {
          // A 4xx (other than 429) is Shopify declining the add; anything else is a failed request.
          var cartError = new Error(body.description || body.message || "Cart request failed");
          cartError.declined = response.status >= 400 && response.status < 500 && response.status !== 429;
          throw cartError;
        }
        return body;
      });
    });
    announceCartAdd(form, variantId, quantity, request);
    return request.then(function (item) { renderHostCart(item); return item; });
  }

  function setGalleryMedia(section, mediaId) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    var selectedThumb = null;
    thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute("data-media-id") === String(mediaId);
      if (active) selectedThumb = thumb;
      thumb.classList.toggle("is-active", active);
      thumb.setAttribute("aria-pressed", String(active));
    });
    items.forEach(function (item) { item.classList.toggle("is-active", item.getAttribute("data-media-id") === String(mediaId)); });
    if (selectedThumb && selectedThumb.scrollIntoView) selectedThumb.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function setupGallery(section) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    if (!thumbs.length || !items.length) return;
    thumbs.forEach(function (thumb) {
      if (!bindOnce(thumb, "gallery")) return;
      thumb.addEventListener("click", function () { setGalleryMedia(section, thumb.getAttribute("data-media-id")); });
    });
  }

  function setupDialog(section) {
    var dialog = section.querySelector("[data-sl-dialog]");
    var openButton = section.querySelector("[data-sl-open-dialog]");
    var closeButton = section.querySelector("[data-sl-close-dialog]");
    if (!dialog || !openButton || !bindOnce(dialog, "dialog")) return;
    var lastFocused = null;
    openButton.addEventListener("click", function () {
      lastFocused = document.activeElement;
      if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
      if (closeButton) closeButton.focus();
    });
    if (closeButton) closeButton.addEventListener("click", function () { if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); });
    dialog.addEventListener("click", function (event) { if (event.target === dialog && typeof dialog.close === "function") dialog.close(); });
    dialog.addEventListener("close", function () { if (lastFocused && lastFocused.focus) lastFocused.focus(); });
  }

  function setupHeader(section) {
    var button = section.querySelector("[data-sl-mobile-menu-button]");
    var drawer = section.querySelector("[data-sl-mobile-drawer]");
    if (!button || !drawer || !bindOnce(button, "menu")) return;
    function close() { button.setAttribute("aria-expanded", "false"); drawer.hidden = true; }
    button.addEventListener("click", function () {
      var expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      drawer.hidden = expanded;
      if (!expanded) { var firstLink = drawer.querySelector("a"); if (firstLink) firstLink.focus(); }
    });
    drawer.querySelectorAll("a").forEach(function (link) { link.addEventListener("click", close); });
    section.addEventListener("keydown", function (event) { if (event.key === "Escape") { close(); button.focus(); } });
  }

  function setupVideoDialogs(section) {
    section.querySelectorAll("[data-sl-video-open]").forEach(function (openButton) {
      if (!bindOnce(openButton, "video-open")) return;
      var dialogId = openButton.getAttribute("aria-controls");
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      var closeButton = dialog.querySelector("[data-sl-video-close]");
      var video = dialog.querySelector("[data-sl-video]");
      openButton.addEventListener("click", function () {
        if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
        if (video && typeof video.play === "function") video.play().catch(function () {});
      });
      function close() { if (video) video.pause(); if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); }
      if (closeButton) closeButton.addEventListener("click", close);
      dialog.addEventListener("click", function (event) { if (event.target === dialog) close(); });
      dialog.addEventListener("close", function () { if (video) video.pause(); });
    });
  }

  function setupQuantity(section) {
    var control = section.querySelector("[data-sl-quantity-control]");
    var input = control && control.querySelector("[data-sl-quantity-input]");
    if (!control || !input || !bindOnce(control, "quantity")) return;
    var choiceInputs = control.querySelectorAll("[data-sl-quantity-choice]");
    function normalize() { var value = Math.max(1, Math.floor(Number(input.value) || 1)); input.value = String(value); return value; }
    function syncChoiceState() { choiceInputs.forEach(function (choice) { var label = choice.closest(".sl-product-quantity-option"); if (label) label.classList.toggle("is-selected", choice.checked); }); }
    control.querySelectorAll("[data-sl-quantity-step]").forEach(function (button) { button.addEventListener("click", function () { input.value = String(Math.max(1, (Number(input.value) || 1) + Number(button.getAttribute("data-sl-quantity-step") || 0))); input.dispatchEvent(new Event("change", { bubbles: true })); }); });
    choiceInputs.forEach(function (choice) { choice.addEventListener("change", function () { input.value = String(Math.max(1, Math.floor(Number(choice.value) || 1))); syncChoiceState(); }); });
    input.addEventListener("change", normalize);
    input.addEventListener("blur", normalize);
    syncChoiceState();
  }

  function variantMediaId(variant) {
    if (!variant) return "";
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_media && typeof variant.featured_media === "number") return variant.featured_media;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    return variant.featured_image && typeof variant.featured_image === "number" ? variant.featured_image : "";
  }

  function setupProductForm(section) {
    var form = section.querySelector("form.sl-product-form");
    if (!form || !bindOnce(form, "product-form")) return;
    var variants = parseJsonScript(section, "[data-sl-variants]");
    var variantInput = form.querySelector("[data-sl-variant-id]");
    var addButton = form.querySelector("[data-sl-add-to-cart]");
    var addLabel = addButton && (addButton.querySelector("[data-sl-add-to-cart-label]") || addButton);
    var status = form.querySelector("[data-sl-form-status]");
    var price = section.querySelector("[data-sl-price]");
    var compareAt = section.querySelector("[data-sl-compare-at]");
    var stickyPrice = section.querySelector("[data-sl-sticky-price]");
    var optionInputs = form.querySelectorAll("[data-sl-option-input]");
    var planInputs = form.querySelectorAll("[data-sl-selling-plan-choice]");
    var currency = section.getAttribute("data-sl-currency") || "USD";
    var labels = { add: section.getAttribute("data-sl-add-label") || "Add to cart", soldOut: section.getAttribute("data-sl-sold-out-label") || "Sold out", adding: section.getAttribute("data-sl-adding-label") || "Adding to cart…", added: section.getAttribute("data-sl-added-label") || "Added to cart.", error: section.getAttribute("data-sl-error-label") || "Unable to add this item." };
    var submitting = false;

    function selectedValues() {
      var values = [];
      optionInputs.forEach(function (input) { if (input.checked) values[Number(input.getAttribute("data-option-position") || 1) - 1] = input.value; });
      return values;
    }
    function findVariant() {
      if (!variants.length) return null;
      var selected = selectedValues();
      return variants.find(function (variant) { var options = Array.isArray(variant.options) ? variant.options : []; return selected.every(function (value, index) { return value === undefined || options[index] === value; }); }) || variants[0];
    }
    function selectedPlanId() { var checked = form.querySelector("[data-sl-selling-plan-choice]:checked"); return checked ? checked.value : ""; }
    function allocationFor(variant, planId) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
      return allocations.find(function (allocation) { return String(allocation.selling_plan_id) === String(planId); }) || null;
    }
    function syncSelectedLabels() {
      section.querySelectorAll("[data-sl-selected-option]").forEach(function (label) { var input = form.querySelector('[data-sl-option-input][data-option-position="' + label.getAttribute("data-sl-selected-option") + '"]:checked'); if (input) label.textContent = input.value; });
      section.querySelectorAll(".sl-product-option").forEach(function (label) { var input = label.querySelector("[data-sl-option-input]"); if (input) label.classList.toggle("is-selected", Boolean(input.checked)); });
    }
    function syncOptionAvailability() {
      var selected = selectedValues();
      optionInputs.forEach(function (input) {
        var optionIndex = Number(input.getAttribute("data-option-position") || 1) - 1;
        var available = variants.some(function (variant) {
          if (variant.available === false) return false;
          var options = Array.isArray(variant.options) ? variant.options : [];
          if (options[optionIndex] !== input.value) return false;
          return selected.every(function (value, index) { return index === optionIndex || value === undefined || options[index] === value; });
        });
        var label = input.closest(".sl-product-option");
        input.disabled = !available && !input.checked;
        input.setAttribute("aria-disabled", String(!available));
        if (label) label.classList.toggle("is-unavailable", !available);
      });
    }
    function syncPlanCards() { form.querySelectorAll("[data-sl-plan-card]").forEach(function (card) { var input = card.querySelector("[data-sl-selling-plan-choice]"); card.classList.toggle("is-selected", Boolean(input && input.checked)); }); }
    function syncPlanPrices(variant) {
      section.querySelectorAll("[data-sl-plan-price]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        if (cents !== undefined) node.textContent = formatMoney(cents, currency);
      });
      // The struck-through price belongs to the same variant (or its plan allocation).
      section.querySelectorAll("[data-sl-plan-compare]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        var compare = allocation && allocation.compare_at_price ? allocation.compare_at_price : variant && variant.compare_at_price;
        var show = Number(compare || 0) > Number(cents || 0);
        node.hidden = !show;
        node.textContent = show ? formatMoney(compare, currency) : "";
      });
    }
    function syncVariant() {
      var variant = findVariant();
      syncOptionAvailability();
      syncSelectedLabels();
      if (!variant) return null;
      var isAvailable = variant.available !== false;
      var formattedPrice = formatMoney(variant.price, currency);
      var selectedPlan = selectedPlanId();
      var selectedAllocation = allocationFor(variant, selectedPlan);
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = selectedAllocation && selectedAllocation.price !== undefined ? formatMoney(selectedAllocation.price, currency) : formattedPrice;
      if (stickyPrice) stickyPrice.textContent = price ? price.textContent : formattedPrice;
      if (compareAt) { var compare = Number(variant.compare_at_price || 0); var current = Number(variant.price || 0); compareAt.hidden = !(compare > current); compareAt.textContent = compare > current ? formatMoney(compare, currency) : ""; }
      if (addButton) { addButton.disabled = !isAvailable || submitting; addLabel.textContent = isAvailable ? labels.add : labels.soldOut; }
      syncPlanPrices(variant);
      syncPlanCards();
      var mediaId = variantMediaId(variant);
      if (mediaId) setGalleryMedia(section, mediaId);
      section.setAttribute("data-selected-variant", String(variant.id));
      return variant;
    }
    // Like the theme's own product form: the URL names the chosen variant, so a
    // shared link or a reload opens it. The wizard's sandboxed preview may refuse
    // the rewrite, which is harmless there.
    function syncVariantUrl() {
      var variant = syncVariant();
      if (!variant) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState(window.history.state, "", url.toString());
      } catch (error) {}
    }
    optionInputs.forEach(function (input) { input.addEventListener("change", syncVariantUrl); });
    planInputs.forEach(function (input) { input.addEventListener("change", syncVariant); });
    setupQuantity(section);
    syncVariant();
    var stickyButton = section.querySelector("[data-sl-mobile-sticky-add]");
    if (stickyButton && bindOnce(stickyButton, "sticky")) stickyButton.addEventListener("click", function () { var variant = syncVariant(); if (!variant || variant.available === false || !addButton) return; if (typeof form.requestSubmit === "function") form.requestSubmit(addButton); else addButton.click(); });
    if (section.getAttribute("data-sl-ajax") !== "true" || !window.fetch || !window.FormData) return;
    loadStandardEvents();
    form.addEventListener("submit", function (event) {
      if (submitting) return;
      event.preventDefault();
      submitting = true;
      if (status) status.textContent = labels.adding;
      syncVariant();
      addToCart(form, section.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = labels.added; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = labels.error; }).finally(function () { submitting = false; syncVariant(); });
    });
  }

  function setupRelatedForms(section) {
    section.querySelectorAll("[data-sl-related-form] form.sl-product-related__form").forEach(function (form) {
      var config = form.closest("[data-sl-related-form]") || section;
      if (!bindOnce(form, "related-form") || config.getAttribute("data-sl-ajax") !== "true") return;
      var button = form.querySelector("[data-sl-related-add]");
      var status = config.querySelector("[data-sl-related-status]");
      form.addEventListener("submit", function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (button) button.disabled = true;
        if (status) status.textContent = config.getAttribute("data-sl-adding-label") || "Adding to cart…";
        addToCart(form, config.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = config.getAttribute("data-sl-added-label") || "Added to cart."; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = config.getAttribute("data-sl-error-label") || "Unable to add this item."; }).finally(function () { if (button) button.disabled = false; });
      });
    });
  }

  // Related products with nothing picked: fetch Shopify's recommendations for
  // this product through the section itself and swap them in.
  function setupRecommendations(section) {
    var url = section.getAttribute("data-sl-related-recommendations");
    if (!url || !window.fetch || !window.DOMParser || !bindOnce(section, "recommendations")) return;
    fetch(url, { headers: { Accept: "text/html" } }).then(function (response) { return response.ok ? response.text() : ""; }).then(function (html) {
      if (!html) return;
      var next = new DOMParser().parseFromString(html, "text/html").querySelector(".sl-product-related");
      if (!next || !next.querySelector(".sl-product-related__card")) return;
      section.replaceWith(next);
      setupWithin(next);
    }).catch(function () { return undefined; });
  }

  function setupTestimonials(section) {
    var tabs = section.querySelectorAll("[data-sl-topic-tab]");
    var cards = section.querySelectorAll("[data-sl-testimonial-card]");
    if (!tabs.length || !cards.length) return;
    // Quotes only (video tiles are not topic cards). Like the React renderer, a
    // tab that matches no quote shows them all rather than an empty grid.
    function applyTopic(topic) {
      var shown = 0;
      cards.forEach(function (card) { var cardTopic = card.getAttribute("data-sl-topic") || "all"; card.hidden = topic !== "all" && cardTopic !== "all" && cardTopic !== topic; if (!card.hidden) shown += 1; });
      if (!shown) cards.forEach(function (card) { card.hidden = false; });
    }
    tabs.forEach(function (tab) { if (!bindOnce(tab, "testimonial-tab")) return; tab.addEventListener("click", function () { var topic = tab.getAttribute("data-sl-topic") || "all"; tabs.forEach(function (candidate) { var active = candidate === tab; candidate.classList.toggle("is-active", active); candidate.setAttribute("aria-selected", String(active)); }); applyTopic(topic); }); });
    applyTopic(tabs[0].getAttribute("data-sl-topic") || "all");
  }

  function setupReviews(section) {
    var list = section.querySelector("[data-sl-review-list]");
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-sl-review-card]"));
    if (!list || !cards.length || !bindOnce(section, "reviews")) return;
    var sortChips = section.querySelectorAll("[data-sl-review-sort]");
    var ratingChips = section.querySelectorAll("[data-sl-review-rating]");
    var more = section.querySelector("[data-sl-review-more]");
    var sortMode = "latest";
    var ratingFilter = "all";
    var showingAll = false;
    var initialCount = 5;
    function number(card, name) { return Number(card.getAttribute(name) || 0); }
    function compare(a, b) {
      if (sortMode === "highest") return number(b, "data-rating") - number(a, "data-rating");
      if (sortMode === "lowest") return number(a, "data-rating") - number(b, "data-rating");
      if (sortMode === "helpful") return number(b, "data-helpful") - number(a, "data-helpful");
      if (sortMode === "oldest") return number(b, "data-review-index") - number(a, "data-review-index");
      return number(a, "data-review-index") - number(b, "data-review-index");
    }
    function apply() {
      var shown = 0;
      cards.slice().sort(compare).forEach(function (card) {
        list.appendChild(card);
        var matches = ratingFilter === "all" || card.getAttribute("data-rating") === ratingFilter;
        card.hidden = !matches || (!showingAll && shown >= initialCount);
        if (matches) shown += 1;
      });
      if (more) more.hidden = showingAll || shown <= initialCount;
    }
    function activate(chips, chosen) {
      chips.forEach(function (chip) { var active = chip === chosen; chip.classList.toggle("is-active", active); chip.setAttribute("aria-pressed", String(active)); });
    }
    sortChips.forEach(function (chip) { chip.addEventListener("click", function () { sortMode = chip.getAttribute("data-sl-review-sort") || "latest"; activate(sortChips, chip); apply(); }); });
    ratingChips.forEach(function (chip) { chip.addEventListener("click", function () { ratingFilter = chip.getAttribute("data-sl-review-rating") || "all"; activate(ratingChips, chip); apply(); }); });
    section.querySelectorAll("[data-sl-review-helpful]").forEach(function (button) { button.addEventListener("click", function () { var active = button.getAttribute("aria-pressed") === "true"; button.setAttribute("aria-pressed", String(!active)); button.classList.toggle("is-active", !active); }); });
    if (more) more.addEventListener("click", function () { showingAll = true; apply(); });
    apply();
  }

  // Long copy behind "Read more" on a phone. The clamp CSS only applies once
  // data-sl-clamp-ready is set, and the button only shows when the clamped
  // text really overflows, so short copy and wide screens never get one.
  function measureClamp(copy, toggle) {
    if (copy.classList.contains("is-expanded")) return;
    var overflows = copy.scrollHeight > copy.clientHeight + 1;
    if (overflows) copy.setAttribute("data-sl-clamp-overflow", ""); else copy.removeAttribute("data-sl-clamp-overflow");
    toggle.hidden = !overflows;
  }

  function setupClamps(root) {
    root.querySelectorAll("[data-sl-clamp]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (!toggle || !toggle.hasAttribute("data-sl-clamp-toggle") || !bindOnce(copy, "clamp")) return;
      copy.setAttribute("data-sl-clamp-ready", "");
      measureClamp(copy, toggle);
      toggle.addEventListener("click", function () {
        var expanded = copy.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        toggle.textContent = toggle.getAttribute(expanded ? "data-sl-less-label" : "data-sl-more-label") || toggle.textContent;
      });
    });
  }

  function remeasureClamps() {
    document.querySelectorAll("[data-sl-clamp-ready]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (toggle && toggle.hasAttribute("data-sl-clamp-toggle")) measureClamp(copy, toggle);
    });
  }

  function setupWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var sections = [];
    if (root.matches && root.matches("[data-sl-product-section]")) sections.push(root);
    root.querySelectorAll("[data-sl-product-section]").forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) { setupGallery(section); setupDialog(section); setupHeader(section); setupVideoDialogs(section); setupProductForm(section); setupRelatedForms(section); setupRecommendations(section); setupTestimonials(section); setupReviews(section); });
    // Every section's copy, not only those that load this script.
    setupClamps(root);
  }

  function setup() {
    setupWithin(document);
    if (document.documentElement.getAttribute("data-sl-global-events") === "true") return;
    document.documentElement.setAttribute("data-sl-global-events", "true");
    document.addEventListener("shopify:section:load", function (event) { setupWithin(event.target); });
    var resizeTimer = 0;
    window.addEventListener("resize", function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(remeasureClamps, 150); });
    // Web fonts change line heights after the first measure.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureClamps);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storelaunch-product-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.__slProductPageScript) return;
  window.__slProductPageScript = true;

  function parseJsonScript(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return [];
    try { return JSON.parse(node.textContent || "[]"); } catch (error) { return []; }
  }

  function bindOnce(node, key) {
    if (!node || node.getAttribute("data-sl-bound-" + key) === "true") return false;
    node.setAttribute("data-sl-bound-" + key, "true");
    return true;
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") return window.Shopify.formatMoney(cents);
    try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency || "USD" }).format(Number(cents || 0) / 100); } catch (error) { return String(cents || ""); }
  }

  function refreshCartCount(section) {
    var url = section && section.getAttribute("data-sl-cart-json-url");
    if (!url || !window.fetch) return Promise.resolve();
    return fetch(url, { headers: { Accept: "application/json" } }).then(function (response) { return response.ok ? response.json() : null; }).then(function (cart) {
      if (!cart || typeof cart.item_count !== "number") return;
      document.querySelectorAll("[data-sl-cart-count]").forEach(function (node) {
        node.textContent = String(cart.item_count);
        var link = node.closest("[data-sl-cart-link]");
        if (link) link.setAttribute("aria-label", (link.getAttribute("data-sl-cart-label-template") || "Cart with __COUNT__ items").replace("__COUNT__", String(cart.item_count)));
      });
    }).catch(function () { return undefined; });
  }

  // The page is often injected into a merchant's own theme, whose header count
  // and cart drawer know nothing about this form. Tell them about each add the
  // way the theme's own product form would.
  var standardEvents = null;
  function loadStandardEvents() {
    if (standardEvents) return standardEvents;
    var url = "";
    try {
      var map = document.querySelector('script[type="importmap"]');
      var imports = map ? JSON.parse(map.textContent || "{}").imports : null;
      url = (imports && imports["@shopify/events"]) || "";
    } catch (error) { url = ""; }
    standardEvents = url ? import(url).catch(function () { return null; }) : Promise.resolve(null);
    return standardEvents;
  }

  function hostCartElement() {
    var element = document.querySelector("cart-notification, cart-drawer");
    return element && typeof element.renderContents === "function" && typeof element.getSectionsToRender === "function" ? element : null;
  }

  function hostCartSectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) === -1) ids.push(String(id)); }
    // Horizon-era themes re-render these from the add response.
    document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (node) { add(node.getAttribute("data-section-id")); });
    // Dawn-family drawers and notifications name their own sections.
    var element = hostCartElement();
    if (element) { try { element.getSectionsToRender().forEach(function (entry) { add(entry && entry.id); }); } catch (error) { return ids; } }
    return ids;
  }

  function cartJsonUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + "cart.js";
  }

  // Shopify's standard storefront events (what Horizon's cart icon and drawer
  // listen for): announce the add before it settles, then resolve with the cart.
  function announceCartAdd(form, variantId, quantity, request) {
    loadStandardEvents().then(function (events) {
      var LinesUpdate = events && events.CartLinesUpdateEvent;
      if (!LinesUpdate) return;
      var deferred = LinesUpdate.createPromise();
      // Listeners attach their own handlers; this only stops an unhandled-rejection log when none does.
      deferred.promise.catch(function () {});
      form.dispatchEvent(new LinesUpdate({ action: "add", context: "product", lines: [{ merchandiseId: variantId, quantity: quantity }], promise: deferred.promise }));
      // Shopify's contract: a declined add resolves with userErrors; a failed
      // request rejects and dispatches shopify:cart:error.
      function settle(item, userErrors) {
        return fetch(cartJsonUrl(), { headers: { Accept: "application/json" } }).then(function (response) { return response.json(); }).then(function (cart) {
          deferred.resolve({ cart: LinesUpdate.createCartFromAjaxResponse(cart), userErrors: userErrors, warnings: [], detail: { items: cart.items, sections: item && item.sections, itemCount: quantity, source: "storelaunch-product-page", didError: userErrors.length > 0 } });
        });
      }
      function fail(error) {
        var CartError = events && events.CartErrorEvent;
        if (CartError) { try { form.dispatchEvent(new CartError({ error: (error && error.message) || "Cart request failed", code: "SERVICE_UNAVAILABLE" })); } catch (dispatchError) { /* a listener must not break the add */ } }
        deferred.reject(error);
      }
      request.then(function (item) { return settle(item, []); }, function (error) {
        if (error && error.declined) return settle(null, [{ message: error.message, code: "INVALID", field: ["lines"] }]);
        fail(error);
      }).catch(fail);
    });
  }

  // Older themes: hand the drawer its refreshed sections, and fire the
  // de-facto cart events other themes and apps listen for.
  function renderHostCart(item) {
    var element = hostCartElement();
    if (element && item && item.sections) {
      try { element.classList.remove("is-empty"); element.renderContents(item); } catch (error) { element = null; }
    }
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: item }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: item }));
      if (typeof window.publish === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "storelaunch-product-page", productVariantId: item && item.variant_id });
      }
    } catch (error) { return undefined; }
  }

  function addToCart(form, url) {
    var data = new FormData(form);
    var sectionIds = hostCartSectionIds();
    if (sectionIds.length) { data.append("sections", sectionIds.join(",")); data.append("sections_url", (window.location && window.location.pathname) || "/"); }
    var variantId = String(data.get("id") || "");
    var quantity = Math.max(1, Number(data.get("quantity")) || 1);
    var request = fetch(url || (form.action + ".js"), { method: "POST", body: data, headers: { Accept: "application/json" } }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.status) {
          // A 4xx (other than 429) is Shopify declining the add; anything else is a failed request.
          var cartError = new Error(body.description || body.message || "Cart request failed");
          cartError.declined = response.status >= 400 && response.status < 500 && response.status !== 429;
          throw cartError;
        }
        return body;
      });
    });
    announceCartAdd(form, variantId, quantity, request);
    return request.then(function (item) { renderHostCart(item); return item; });
  }

  function setGalleryMedia(section, mediaId) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    var selectedThumb = null;
    thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute("data-media-id") === String(mediaId);
      if (active) selectedThumb = thumb;
      thumb.classList.toggle("is-active", active);
      thumb.setAttribute("aria-pressed", String(active));
    });
    items.forEach(function (item) { item.classList.toggle("is-active", item.getAttribute("data-media-id") === String(mediaId)); });
    if (selectedThumb && selectedThumb.scrollIntoView) selectedThumb.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function setupGallery(section) {
    var thumbs = section.querySelectorAll("[data-sl-gallery-thumb]");
    var items = section.querySelectorAll("[data-sl-gallery-item]");
    if (!thumbs.length || !items.length) return;
    thumbs.forEach(function (thumb) {
      if (!bindOnce(thumb, "gallery")) return;
      thumb.addEventListener("click", function () { setGalleryMedia(section, thumb.getAttribute("data-media-id")); });
    });
  }

  function setupDialog(section) {
    var dialog = section.querySelector("[data-sl-dialog]");
    var openButton = section.querySelector("[data-sl-open-dialog]");
    var closeButton = section.querySelector("[data-sl-close-dialog]");
    if (!dialog || !openButton || !bindOnce(dialog, "dialog")) return;
    var lastFocused = null;
    openButton.addEventListener("click", function () {
      lastFocused = document.activeElement;
      if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
      if (closeButton) closeButton.focus();
    });
    if (closeButton) closeButton.addEventListener("click", function () { if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); });
    dialog.addEventListener("click", function (event) { if (event.target === dialog && typeof dialog.close === "function") dialog.close(); });
    dialog.addEventListener("close", function () { if (lastFocused && lastFocused.focus) lastFocused.focus(); });
  }

  function setupHeader(section) {
    var button = section.querySelector("[data-sl-mobile-menu-button]");
    var drawer = section.querySelector("[data-sl-mobile-drawer]");
    if (!button || !drawer || !bindOnce(button, "menu")) return;
    function close() { button.setAttribute("aria-expanded", "false"); drawer.hidden = true; }
    button.addEventListener("click", function () {
      var expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      drawer.hidden = expanded;
      if (!expanded) { var firstLink = drawer.querySelector("a"); if (firstLink) firstLink.focus(); }
    });
    drawer.querySelectorAll("a").forEach(function (link) { link.addEventListener("click", close); });
    section.addEventListener("keydown", function (event) { if (event.key === "Escape") { close(); button.focus(); } });
  }

  function setupVideoDialogs(section) {
    section.querySelectorAll("[data-sl-video-open]").forEach(function (openButton) {
      if (!bindOnce(openButton, "video-open")) return;
      var dialogId = openButton.getAttribute("aria-controls");
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      var closeButton = dialog.querySelector("[data-sl-video-close]");
      var video = dialog.querySelector("[data-sl-video]");
      openButton.addEventListener("click", function () {
        if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute("open", "");
        if (video && typeof video.play === "function") video.play().catch(function () {});
      });
      function close() { if (video) video.pause(); if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open"); }
      if (closeButton) closeButton.addEventListener("click", close);
      dialog.addEventListener("click", function (event) { if (event.target === dialog) close(); });
      dialog.addEventListener("close", function () { if (video) video.pause(); });
    });
  }

  function setupQuantity(section) {
    var control = section.querySelector("[data-sl-quantity-control]");
    var input = control && control.querySelector("[data-sl-quantity-input]");
    if (!control || !input || !bindOnce(control, "quantity")) return;
    var choiceInputs = control.querySelectorAll("[data-sl-quantity-choice]");
    function normalize() { var value = Math.max(1, Math.floor(Number(input.value) || 1)); input.value = String(value); return value; }
    function syncChoiceState() { choiceInputs.forEach(function (choice) { var label = choice.closest(".sl-product-quantity-option"); if (label) label.classList.toggle("is-selected", choice.checked); }); }
    control.querySelectorAll("[data-sl-quantity-step]").forEach(function (button) { button.addEventListener("click", function () { input.value = String(Math.max(1, (Number(input.value) || 1) + Number(button.getAttribute("data-sl-quantity-step") || 0))); input.dispatchEvent(new Event("change", { bubbles: true })); }); });
    choiceInputs.forEach(function (choice) { choice.addEventListener("change", function () { input.value = String(Math.max(1, Math.floor(Number(choice.value) || 1))); syncChoiceState(); }); });
    input.addEventListener("change", normalize);
    input.addEventListener("blur", normalize);
    syncChoiceState();
  }

  function variantMediaId(variant) {
    if (!variant) return "";
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_media && typeof variant.featured_media === "number") return variant.featured_media;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    return variant.featured_image && typeof variant.featured_image === "number" ? variant.featured_image : "";
  }

  function setupProductForm(section) {
    var form = section.querySelector("form.sl-product-form");
    if (!form || !bindOnce(form, "product-form")) return;
    var variants = parseJsonScript(section, "[data-sl-variants]");
    var variantInput = form.querySelector("[data-sl-variant-id]");
    var addButton = form.querySelector("[data-sl-add-to-cart]");
    var addLabel = addButton && (addButton.querySelector("[data-sl-add-to-cart-label]") || addButton);
    var status = form.querySelector("[data-sl-form-status]");
    var price = section.querySelector("[data-sl-price]");
    var compareAt = section.querySelector("[data-sl-compare-at]");
    var stickyPrice = section.querySelector("[data-sl-sticky-price]");
    var optionInputs = form.querySelectorAll("[data-sl-option-input]");
    var planInputs = form.querySelectorAll("[data-sl-selling-plan-choice]");
    var currency = section.getAttribute("data-sl-currency") || "USD";
    var labels = { add: section.getAttribute("data-sl-add-label") || "Add to cart", soldOut: section.getAttribute("data-sl-sold-out-label") || "Sold out", adding: section.getAttribute("data-sl-adding-label") || "Adding to cart…", added: section.getAttribute("data-sl-added-label") || "Added to cart.", error: section.getAttribute("data-sl-error-label") || "Unable to add this item." };
    var submitting = false;

    function selectedValues() {
      var values = [];
      optionInputs.forEach(function (input) { if (input.checked) values[Number(input.getAttribute("data-option-position") || 1) - 1] = input.value; });
      return values;
    }
    function findVariant() {
      if (!variants.length) return null;
      var selected = selectedValues();
      return variants.find(function (variant) { var options = Array.isArray(variant.options) ? variant.options : []; return selected.every(function (value, index) { return value === undefined || options[index] === value; }); }) || variants[0];
    }
    function selectedPlanId() { var checked = form.querySelector("[data-sl-selling-plan-choice]:checked"); return checked ? checked.value : ""; }
    function allocationFor(variant, planId) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
      return allocations.find(function (allocation) { return String(allocation.selling_plan_id) === String(planId); }) || null;
    }
    function syncSelectedLabels() {
      section.querySelectorAll("[data-sl-selected-option]").forEach(function (label) { var input = form.querySelector('[data-sl-option-input][data-option-position="' + label.getAttribute("data-sl-selected-option") + '"]:checked'); if (input) label.textContent = input.value; });
      section.querySelectorAll(".sl-product-option").forEach(function (label) { var input = label.querySelector("[data-sl-option-input]"); if (input) label.classList.toggle("is-selected", Boolean(input.checked)); });
    }
    function syncOptionAvailability() {
      var selected = selectedValues();
      optionInputs.forEach(function (input) {
        var optionIndex = Number(input.getAttribute("data-option-position") || 1) - 1;
        var available = variants.some(function (variant) {
          if (variant.available === false) return false;
          var options = Array.isArray(variant.options) ? variant.options : [];
          if (options[optionIndex] !== input.value) return false;
          return selected.every(function (value, index) { return index === optionIndex || value === undefined || options[index] === value; });
        });
        var label = input.closest(".sl-product-option");
        input.disabled = !available && !input.checked;
        input.setAttribute("aria-disabled", String(!available));
        if (label) label.classList.toggle("is-unavailable", !available);
      });
    }
    function syncPlanCards() { form.querySelectorAll("[data-sl-plan-card]").forEach(function (card) { var input = card.querySelector("[data-sl-selling-plan-choice]"); card.classList.toggle("is-selected", Boolean(input && input.checked)); }); }
    function syncPlanPrices(variant) {
      section.querySelectorAll("[data-sl-plan-price]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        if (cents !== undefined) node.textContent = formatMoney(cents, currency);
      });
      // The struck-through price belongs to the same variant (or its plan allocation).
      section.querySelectorAll("[data-sl-plan-compare]").forEach(function (node) {
        var planId = node.getAttribute("data-sl-plan-id");
        var allocation = planId ? allocationFor(variant, planId) : null;
        var cents = allocation && allocation.price !== undefined ? allocation.price : variant && variant.price;
        var compare = allocation && allocation.compare_at_price ? allocation.compare_at_price : variant && variant.compare_at_price;
        var show = Number(compare || 0) > Number(cents || 0);
        node.hidden = !show;
        node.textContent = show ? formatMoney(compare, currency) : "";
      });
    }
    function syncVariant() {
      var variant = findVariant();
      syncOptionAvailability();
      syncSelectedLabels();
      if (!variant) return null;
      var isAvailable = variant.available !== false;
      var formattedPrice = formatMoney(variant.price, currency);
      var selectedPlan = selectedPlanId();
      var selectedAllocation = allocationFor(variant, selectedPlan);
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = selectedAllocation && selectedAllocation.price !== undefined ? formatMoney(selectedAllocation.price, currency) : formattedPrice;
      if (stickyPrice) stickyPrice.textContent = price ? price.textContent : formattedPrice;
      if (compareAt) { var compare = Number(variant.compare_at_price || 0); var current = Number(variant.price || 0); compareAt.hidden = !(compare > current); compareAt.textContent = compare > current ? formatMoney(compare, currency) : ""; }
      if (addButton) { addButton.disabled = !isAvailable || submitting; addLabel.textContent = isAvailable ? labels.add : labels.soldOut; }
      syncPlanPrices(variant);
      syncPlanCards();
      var mediaId = variantMediaId(variant);
      if (mediaId) setGalleryMedia(section, mediaId);
      section.setAttribute("data-selected-variant", String(variant.id));
      return variant;
    }
    // Like the theme's own product form: the URL names the chosen variant, so a
    // shared link or a reload opens it. The wizard's sandboxed preview may refuse
    // the rewrite, which is harmless there.
    function syncVariantUrl() {
      var variant = syncVariant();
      if (!variant) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState(window.history.state, "", url.toString());
      } catch (error) {}
    }
    optionInputs.forEach(function (input) { input.addEventListener("change", syncVariantUrl); });
    planInputs.forEach(function (input) { input.addEventListener("change", syncVariant); });
    setupQuantity(section);
    syncVariant();
    var stickyButton = section.querySelector("[data-sl-mobile-sticky-add]");
    if (stickyButton && bindOnce(stickyButton, "sticky")) stickyButton.addEventListener("click", function () { var variant = syncVariant(); if (!variant || variant.available === false || !addButton) return; if (typeof form.requestSubmit === "function") form.requestSubmit(addButton); else addButton.click(); });
    if (section.getAttribute("data-sl-ajax") !== "true" || !window.fetch || !window.FormData) return;
    loadStandardEvents();
    form.addEventListener("submit", function (event) {
      if (submitting) return;
      event.preventDefault();
      submitting = true;
      if (status) status.textContent = labels.adding;
      syncVariant();
      addToCart(form, section.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = labels.added; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = labels.error; }).finally(function () { submitting = false; syncVariant(); });
    });
  }

  function setupRelatedForms(section) {
    section.querySelectorAll("[data-sl-related-form] form.sl-product-related__form").forEach(function (form) {
      var config = form.closest("[data-sl-related-form]") || section;
      if (!bindOnce(form, "related-form") || config.getAttribute("data-sl-ajax") !== "true") return;
      var button = form.querySelector("[data-sl-related-add]");
      var status = config.querySelector("[data-sl-related-status]");
      form.addEventListener("submit", function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (button) button.disabled = true;
        if (status) status.textContent = config.getAttribute("data-sl-adding-label") || "Adding to cart…";
        addToCart(form, config.getAttribute("data-sl-ajax-url")).then(function () { if (status) status.textContent = config.getAttribute("data-sl-added-label") || "Added to cart."; return refreshCartCount(section); }).catch(function () { if (status) status.textContent = config.getAttribute("data-sl-error-label") || "Unable to add this item."; }).finally(function () { if (button) button.disabled = false; });
      });
    });
  }

  // Related products with nothing picked: fetch Shopify's recommendations for
  // this product through the section itself and swap them in.
  function setupRecommendations(section) {
    var url = section.getAttribute("data-sl-related-recommendations");
    if (!url || !window.fetch || !window.DOMParser || !bindOnce(section, "recommendations")) return;
    fetch(url, { headers: { Accept: "text/html" } }).then(function (response) { return response.ok ? response.text() : ""; }).then(function (html) {
      if (!html) return;
      var next = new DOMParser().parseFromString(html, "text/html").querySelector(".sl-product-related");
      if (!next || !next.querySelector(".sl-product-related__card")) return;
      section.replaceWith(next);
      setupWithin(next);
    }).catch(function () { return undefined; });
  }

  function setupTestimonials(section) {
    var tabs = section.querySelectorAll("[data-sl-topic-tab]");
    var cards = section.querySelectorAll("[data-sl-testimonial-card]");
    if (!tabs.length || !cards.length) return;
    // Quotes only (video tiles are not topic cards). Like the React renderer, a
    // tab that matches no quote shows them all rather than an empty grid.
    function applyTopic(topic) {
      var shown = 0;
      cards.forEach(function (card) { var cardTopic = card.getAttribute("data-sl-topic") || "all"; card.hidden = topic !== "all" && cardTopic !== "all" && cardTopic !== topic; if (!card.hidden) shown += 1; });
      if (!shown) cards.forEach(function (card) { card.hidden = false; });
    }
    tabs.forEach(function (tab) { if (!bindOnce(tab, "testimonial-tab")) return; tab.addEventListener("click", function () { var topic = tab.getAttribute("data-sl-topic") || "all"; tabs.forEach(function (candidate) { var active = candidate === tab; candidate.classList.toggle("is-active", active); candidate.setAttribute("aria-selected", String(active)); }); applyTopic(topic); }); });
    applyTopic(tabs[0].getAttribute("data-sl-topic") || "all");
  }

  function setupReviews(section) {
    var list = section.querySelector("[data-sl-review-list]");
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-sl-review-card]"));
    if (!list || !cards.length || !bindOnce(section, "reviews")) return;
    var sortChips = section.querySelectorAll("[data-sl-review-sort]");
    var ratingChips = section.querySelectorAll("[data-sl-review-rating]");
    var more = section.querySelector("[data-sl-review-more]");
    var sortMode = "latest";
    var ratingFilter = "all";
    var showingAll = false;
    var initialCount = 5;
    function number(card, name) { return Number(card.getAttribute(name) || 0); }
    function compare(a, b) {
      if (sortMode === "highest") return number(b, "data-rating") - number(a, "data-rating");
      if (sortMode === "lowest") return number(a, "data-rating") - number(b, "data-rating");
      if (sortMode === "helpful") return number(b, "data-helpful") - number(a, "data-helpful");
      if (sortMode === "oldest") return number(b, "data-review-index") - number(a, "data-review-index");
      return number(a, "data-review-index") - number(b, "data-review-index");
    }
    function apply() {
      var shown = 0;
      cards.slice().sort(compare).forEach(function (card) {
        list.appendChild(card);
        var matches = ratingFilter === "all" || card.getAttribute("data-rating") === ratingFilter;
        card.hidden = !matches || (!showingAll && shown >= initialCount);
        if (matches) shown += 1;
      });
      if (more) more.hidden = showingAll || shown <= initialCount;
    }
    function activate(chips, chosen) {
      chips.forEach(function (chip) { var active = chip === chosen; chip.classList.toggle("is-active", active); chip.setAttribute("aria-pressed", String(active)); });
    }
    sortChips.forEach(function (chip) { chip.addEventListener("click", function () { sortMode = chip.getAttribute("data-sl-review-sort") || "latest"; activate(sortChips, chip); apply(); }); });
    ratingChips.forEach(function (chip) { chip.addEventListener("click", function () { ratingFilter = chip.getAttribute("data-sl-review-rating") || "all"; activate(ratingChips, chip); apply(); }); });
    section.querySelectorAll("[data-sl-review-helpful]").forEach(function (button) { button.addEventListener("click", function () { var active = button.getAttribute("aria-pressed") === "true"; button.setAttribute("aria-pressed", String(!active)); button.classList.toggle("is-active", !active); }); });
    if (more) more.addEventListener("click", function () { showingAll = true; apply(); });
    apply();
  }

  // Long copy behind "Read more" on a phone. The clamp CSS only applies once
  // data-sl-clamp-ready is set, and the button only shows when the clamped
  // text really overflows, so short copy and wide screens never get one.
  function measureClamp(copy, toggle) {
    if (copy.classList.contains("is-expanded")) return;
    var overflows = copy.scrollHeight > copy.clientHeight + 1;
    if (overflows) copy.setAttribute("data-sl-clamp-overflow", ""); else copy.removeAttribute("data-sl-clamp-overflow");
    toggle.hidden = !overflows;
  }

  function setupClamps(root) {
    root.querySelectorAll("[data-sl-clamp]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (!toggle || !toggle.hasAttribute("data-sl-clamp-toggle") || !bindOnce(copy, "clamp")) return;
      copy.setAttribute("data-sl-clamp-ready", "");
      measureClamp(copy, toggle);
      toggle.addEventListener("click", function () {
        var expanded = copy.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        toggle.textContent = toggle.getAttribute(expanded ? "data-sl-less-label" : "data-sl-more-label") || toggle.textContent;
      });
    });
  }

  function remeasureClamps() {
    document.querySelectorAll("[data-sl-clamp-ready]").forEach(function (copy) {
      var toggle = copy.nextElementSibling;
      if (toggle && toggle.hasAttribute("data-sl-clamp-toggle")) measureClamp(copy, toggle);
    });
  }

  function setupWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var sections = [];
    if (root.matches && root.matches("[data-sl-product-section]")) sections.push(root);
    root.querySelectorAll("[data-sl-product-section]").forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) { setupGallery(section); setupDialog(section); setupHeader(section); setupVideoDialogs(section); setupProductForm(section); setupRelatedForms(section); setupRecommendations(section); setupTestimonials(section); setupReviews(section); });
    // Every section's copy, not only those that load this script.
    setupClamps(root);
  }

  function setup() {
    setupWithin(document);
    if (document.documentElement.getAttribute("data-sl-global-events") === "true") return;
    document.documentElement.setAttribute("data-sl-global-events", "true");
    document.addEventListener("shopify:section:load", function (event) { setupWithin(event.target); });
    var resizeTimer = 0;
    window.addEventListener("resize", function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(remeasureClamps, 150); });
    // Web fonts change line heights after the first measure.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureClamps);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
})();

  } catch(e) { console.error(e); }
})();
})();
